import { Component, EventEmitter, Input, Output } from '@angular/core';
import { COMMON_MODULES } from '@src/app/core/constants';

@Component({
  selector: 'app-mini-env-bg-content',
  imports: [...COMMON_MODULES],
  templateUrl: './mini-env-bg-content.component.html',
  styleUrl: './mini-env-bg-content.component.scss'
})
export class MiniEnvBgContentComponent {
  @Input() bgClass: any = '';
  @Input() title: any = '';
  @Input() description: any = '';

  @Output() buttonAction = new EventEmitter();
  @Input() mobileTitle: any;

  onButtonClick() {
    this.buttonAction.emit();
  }
}
